class ClaroluzModal {
    protected modal: any;
    protected id: string;

    constructor(library: Function, id: string) {
        this.id = id;
        this.modal = library;
        this.modal.init();
    }

    public show() {
        this.modal.open(this.id);
    }

    public hide() {
        this.modal.close();
    }
}

//removeIf(production)
export default ClaroluzModal;
//endRemoveIf(production)